<template>
    <nav class="glossary-nav">
        <ul>
            <li v-for="letter in allLetters" :key="letter">
                <a
                    href="#"
                    :class="{
                        active: activeLetter === letter,
                        disabled: !availableLetters.includes(letter)
                    }"
                    @click.prevent="availableLetters.includes(letter) && emit('letterSelected', letter)"
                >
                    {{ letter }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const allLetters = "▲ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

defineProps({
    availableLetters: {
        type: Array,
        required: true,
    },
    activeLetter: {
        type: String,
        default: "A",
    },
});

const emit = defineEmits(["letterSelected"]);
</script>

<style scoped>
.glossary-nav ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.glossary-nav li {
    margin-bottom: 5px;
}

.glossary-nav a {
    display: block;
    padding: 8px 0;
    text-align: center;
    text-decoration: none;
    color: #a11128;
    font-weight: bold;
    transition: background-color 0.2s, color 0.2s;
    border-radius: 4px;
}

.glossary-nav a:hover {
    background-color: #e0e0e0;
    color: #333;
}

.glossary-nav a.active {
    background-color: #007bff;
    color: white;
    pointer-events: none;
}

.glossary-nav a.disabled {
    color: #ccc;
    pointer-events: none;
    background: none;
    cursor: default;
}
</style>